"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthzCookie = exports.rmAuthzCookie = exports.getAuthzCookie = void 0;
var _session = require("./session.js");
var getAuthzCookie = function getAuthzCookie(cacheName) {
  return function () {
    return (0, _session.getItemJSON)(cacheName) || undefined;
  };
};
exports.getAuthzCookie = getAuthzCookie;
var rmAuthzCookie = function rmAuthzCookie(cacheName) {
  return (0, _session.rmItem)(cacheName);
};
exports.rmAuthzCookie = rmAuthzCookie;
var setAuthzCookie = function setAuthzCookie(cacheName) {
  return function (auth) {
    return (0, _session.setItem)(cacheName)(JSON.stringify(auth));
  };
};
exports.setAuthzCookie = setAuthzCookie;